// Copyright 2026. WebPros International GmbH. All rights reserved.

import { PropsValue } from 'react-select';
import {
    ILoadOptions,
    ISelectRequiredOption,
} from 'common/components';
import * as React from 'react';
import AsyncSelectInput from 'common/components/Select/AsyncSelectInput';
import { FILTERS } from 'admin/common/constants/tests';
import { FixedFormField } from 'admin/common/components/Filters/Styles';
import { computeResourceVms } from 'common/api/resources/ComputeResourceVm';
import { Translate } from '@plesk/ui-library';

export interface IComputeResourceVmFilterProps {
    onChange?: (option: PropsValue<ISelectRequiredOption>) => void;
    value?: PropsValue<ISelectRequiredOption>;
}

export const ComputeResourceVmFilter: React.FC<IComputeResourceVmFilterProps> = ({
    onChange,
    value,
}) => {
    const loadComputeResourceVms: ILoadOptions<PropsValue<ISelectRequiredOption>> = async (search, loadedOptions, { page } = { page: 1 }) => {
        const response = await computeResourceVms.list({
            page,
            filters: {
                search,
            },
        });

        return {
            options: response.data.data.map(computeResourceVm => ({
                label: computeResourceVm.name,
                value: computeResourceVm.id.toString(),
            })),
            hasMore: !!response.data.links.next,
            additional: {
                page: page + 1,
            },
        };
    };

    return (
        <FixedFormField data-cy={FILTERS.COMPUTE_RESOURCE_VM}>
            <AsyncSelectInput
                isClearable={true}
                placeholder={<Translate content="filters.computeResourceVm"/>}
                loadOptions={loadComputeResourceVms}
                onChange={onChange}
                debounceTimeout={1000}
                additional={{ page: 1 }}
                value={value}
                menuPosition="absolute"
                menuPortalTarget={document.body}
            />
        </FixedFormField>
    );
};
